import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import Slide from './slide';

import './carousel.css';

export default class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChanging: false,
    };
  }

  render() {
    const { block } = this.props;
    const { isChanging } = this.state;

    const slides = [];
    const pages = [];

    const repeater = block.getIn(['fields', 'images']);
    repeater.get('blocks').forEach((slide, idx) => {
      slides.push(<Slide block={slide} key={`slide-${idx + 1}`} isChanging={isChanging} />);
      pages.push(<a href="#goto" key={`page-${idx + 1}`}>Slide {idx}</a>);
    });

    const settings = {
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: () => {
        this.setState({ isChanging: true });
      },
      afterChange: () => {
        this.setState({ isChanging: false });
      },
    };

    return (
      <div className="block-carousel">
        <Slider {...settings}>{slides}</Slider>
      </div>
      // <div className="block-carousel">
      //     <div className="slides">{slides}</div>
      //     <div className="pager">{pages}</div>
      // </div>
    );
  }
}

Carousel.propTypes = {
  block: PropTypes.object.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/blocks/carousel/index.jsx